import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import IconButton from 'material-ui/IconButton';
import { numberWithCommas, checkProfilePic } from '../utility/tool';
import ProfileSection2 from '../components/profileSection2';
import icon_user from "../imgs/icons8-user-60.png";

const infoIconStyle = {
  iconStyle: {
  	color:"#1f90e5",
  },
}

export default class ProfileSectionTop extends Component{
	checkNumOfFans(number) {
		if(number){
			return ''
		}else{
			return 'hideNumber'
		}
	}

	checkYtSubscribers(hidden, number) {
		if (hidden) {
			return number > 0 ? 'hidden':'na'
		} else {
			return number > 0 ? '':'hideNumber'
		}
	}

	checkHiddenMsg(hidden, number) {
		if (hidden && number === 0) {
			return '此頻道已隱藏粉絲數'
		} else {
			return '此頻道已隱藏粉絲數，此為隱藏前的最後更新數值'
		}
	}

	checkMetaValue() {
		const { metaValue } = this.props

		if (metaValue) {
			return 	<ProfileSection2 leaderInfo={this.props.leaderInfo} />
		}

	}

	render () {
		// handle data from leaderInfo
		const leaderInfo = this.props.leaderInfo
		const leaderCategory = leaderInfo.category || 'N/A'
		const numberOfFbFans = Math.round(leaderInfo.facebook_fans)
		const numberOfYtFans = Math.round(leaderInfo.youtube_fans)
		const numberOfIgFans = Math.round(leaderInfo.instagram_fans)

	  	return (
	  		<div className="profileSectionWrapper">
	  			<div className="goBackBox" onClick={browserHistory.goBack}>
	  				<span className="icon_return"></span>
	  				<p className="message">Back</p>
	  			</div>
	  			<div className="profile_section1">
	  				<div className="profilePic">
	  					<img src={checkProfilePic(leaderInfo)} alt="fangroup_img" onError={(e)=>{e.target.onerror = null; e.target.src = icon_user}}/>
	  				</div>
	  				<div className="profileInfo">
	  					<div className="titleAttrWrapper">
	  						<div className="leaderTitle">
	  							<p className="name">{leaderInfo.name}</p>
	  						</div>
	  						<p className="leaderAttribute">
	  							屬性：{leaderCategory}
	  						</p>
	  					</div>
	  					<div className="fanScaleWrapper">
	  						<a href={leaderInfo.fblink} target="_blank" className={`leaderNumber fb ${this.checkNumOfFans(numberOfFbFans)}`}>
	  							<span className="k_sprite1 sprite-icon-facebook"></span>
	  							<span className="title">粉絲數</span>
	  							<span className="value">{numberWithCommas(numberOfFbFans)}</span>
	  						</a>
	  						<div className={`ytBtnWrapper ${this.checkYtSubscribers(leaderInfo.yt_hidden_subscriber, numberOfYtFans)}`}>
		  						<a href={leaderInfo.ytlink} target="_blank" className={`leaderNumber yt`}>
		  							<span className="k_sprite1 sprite-icon-yt"></span>
		  							<span className="title">粉絲數</span>
		  							<span className="value">{numberOfYtFans === 0 ? '--':numberWithCommas(numberOfYtFans)}</span>
		  						</a>
	  							<p className="hiddenMsg">
			  						<IconButton
											className="infoIcon disabledCursor"
											iconClassName="material-icons"
											iconStyle={infoIconStyle.iconStyle}
											disableTouchRipple={true}
			  						>
			  							info
			  						</IconButton>
			  						<span className='msg'>{this.checkHiddenMsg(leaderInfo.yt_hidden_subscriber, numberOfYtFans)}</span>
		  						</p>
	  						</div>
	  						<a href={leaderInfo.iglink} target="_blank" className={`leaderNumber ig ${this.checkNumOfFans(numberOfIgFans)}`}>
	  							<span className="k_sprite1 sprite-icon-ig"></span>
	  							<span className="title">粉絲數</span>
	  							<span className="value">{numberWithCommas(numberOfIgFans)}</span>
	  						</a>
	  					</div>
	  				</div>
	  			</div>
	  			{this.checkMetaValue()}
	  		</div>
	    );
  	}
}



// WEBPACK FOOTER //
// ./src/components/profileSectionTop.js